import Image from 'next/image';

import { logger } from '@/lib/logger';

type ImgProps = {
  src: string;
  alt: string;
  className?: string;
  dimensions?: { width: number; height: number };
  priority?: boolean;
  fill?: boolean;
  sizes?: string;
  onClick?: () => void;
  eager?: boolean;
};

const Img = ({ src, alt, className, dimensions, priority, fill, sizes, onClick, eager }: ImgProps) => {
  if (!src) {
    logger.warn('Img component called without src');
    return null;
  }

  if (fill) {
    return (
      <Image src={src} alt={alt} className={className} fill sizes={sizes || '100%'} priority={!eager ? priority : undefined} onClick={onClick} loading={eager && !priority ? 'eager' : undefined} />
    );
  }
  return (
    <Image
      src={src}
      alt={alt}
      className={className}
      width={dimensions?.width || 1024}
      height={dimensions?.height || 768}
      priority={!eager ? priority : undefined}
      onClick={onClick}
      loading={eager && !priority ? 'eager' : undefined}
    />
  );
};

export default Img;
